<template>
  <div class="ordered-container">
    <el-table :data="productList"
              size="mini"
              style="width: 100%"
              height="100%">
      <el-table-column prop="createOn"
                       label="创建时间"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.createOn | date }}
        </template>
      </el-table-column>
      <el-table-column prop="productName"
                       label="物料名称"> </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="price"
                       label="价格"> </el-table-column>
      <el-table-column prop="priceDate"
                       label="价格有效期"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.priceDate | date }}
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       width="200"> </el-table-column>
      <!-- <el-table-column prop="orderQuantity" label="订单数量"> </el-table-column> -->
      <el-table-column prop="orderDate"
                       label="订单时间"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.orderDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="产品图片">
        <template slot-scope="scope">
          <el-image style="width: 40px; height: 40px"
                    v-if="scope.row.uploadFiles.length > 0"
                    :src="scope.row.uploadFiles[0].sitePath"
                    :preview-src-list="previewFiles(scope.row.uploadFiles)">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    productList: {
      type: Array,
      default: () => {
        return [
          {
            createOn: '',
            productName: '',
            orderQuantity: '',
            price: 0,
            priceDate: '',
            quality: {
              code: '',
              id: '',
              name: ''
            },
            qualityId: '',
            remark: '',
            uploadFiles: [
              {
                contentType: '',
                id: 1,
                name: '',
                sitePath: ''
              }
            ]
          }
        ]
      }
    }
  },
  data () {
    return {}
  },
  created () { },
  methods: {
    previewFiles (files) {
      let arr = []
      files.forEach(item => {
        arr.push(item.sitePath)
      })
      return arr
    }
  }
}
</script>
<style lang="less" scoped>
.ordered-container {
  height: 100%;
  overflow: auto;
}
</style>
